// import React, { useContext } from 'react'
// import { Routes, Route } from 'react-router-dom'

// import AgentHome from './screens/agent/HomeAgentContainer'
// import AgentClients from './screens/agent/ClientsContainer'
// import AgentStatistic from './screens/agent/StatisticContainer'
// import AdminHome from './screens/admin/HomeAdminContainer'
// import SuperAdminHome from './screens/superAdmin/HomeSuperAdminContainer'
// import SuperAgentHome from './screens/superAgent/HomeSuperAgentContainer'
// import Login from './screens/LoginContainer'
// import Client from './screens/ClientsContainer'
// import Transfert from './screens/TransfertContainer'
// import Invoice from './screens/InvoiceContainer'
// import Insurance from './screens/inssuranceContainer'
// import DetailUser from './screens/DetailUserContainer'
// import Settings from './screens/Settings'
// import ProtectedRoute from './helpers/routeProtected'
// import Layout from './layout/layout'
// import { UserContext } from './contexts/UserContext'

// const PagesRoutes = () => {
//   const { user } = useContext(UserContext)

//   return (
//     <Routes>
//       {/* Route publique (Login) */}
//       <Route element={<Layout hideHeader />}>
//         <Route path="/login" element={<Login />} />
//       </Route>

//       {/* Routes Protégées */}
//       <Route element={<ProtectedRoute isAuthenticated={user?.success} />}>
//         <Route element={<Layout hideHeader={false} />}>
//           {/* Homes selon les rôles */}
//           <Route path="/agent-home" element={<AgentHome />} />
//           <Route path="/agent-clients" element={<AgentClients />} />
//           <Route path="/agent-statistic" element={<AgentStatistic />} />
//           <Route path="/admin-home" element={<AdminHome />} />
//           <Route path="/super-admin-home" element={<SuperAdminHome />} />
//           <Route path="/super-agent-home" element={<SuperAgentHome />} />

//           {/* Écrans partagés */}
//           <Route path="/detailuser/:id" element={<DetailUser />} />
//           <Route path="/transfert" element={<Transfert />} />
//           <Route path="/clients" element={<Client />} />
//           <Route path="/invoice" element={<Invoice />} />
//           <Route path="/insurance" element={<Insurance />} />
//           <Route path="/settings" element={<Settings />} />
//         </Route>
//       </Route>

//       {/* 404 */}
//       <Route path="*" element={<div>404 not found</div>} />
//     </Routes>
//   )
// }

// export default PagesRoutes

import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { UserContext } from "./contexts/UserContext";
import AgentHome from "./screens/agent/HomeAgentContainer";
import AgentClients from "./screens/agent/ClientsContainer";
import AgentStatistic from "./screens/agent/StatisticContainer";
import AdminHome from "./screens/admin/HomeAdminContainer";
import SuperAdminHome from "./screens/superAdmin/HomeSuperAdminContainer";
import SuperAgentHome from "./screens/superAgent/HomeSuperAgentContainer";
import Login from "./screens/LoginContainer";
import Client from "./screens/ClientsContainer";
import Transfert from "./screens/TransfertContainer";
import Invoice from "./screens/InvoiceContainer";
import Insurance from "./screens/inssuranceContainer";
import DetailUser from "./screens/DetailUserContainer";
import Settings from "./screens/Settings";
import ProtectedRoute from "./helpers/routeProtected";
import Layout from "./layout/layout";
import Live from "./screens/superAgent/live";
import StatisticScreen from "./screens/superAgent/StatisticSupAgent";
import Blog from "./screens/marketing/Blog";
import Finance from "./screens/superAdmin/Finance";
import NotificationManager from "./screens/Notification";
import HomeMarketing from "./screens/marketing/HomeMarketing";
import ListBlogs from "./screens/marketing/ListBlogs";
import DetailArticle from "./screens/marketing/DetailArticle";
import PreviewArticle from "./screens/marketing/PreviewArticle";
import Gamification from "./screens/marketing/Gamification";
import GameDetailsByUser from "./screens/marketing/GameDetailsByUser";

const PagesRoutes = () => {
  const { user } = useContext(UserContext);
  const role = user?.user?.role;
  const isAuth = user?.success;

  return (
    <Routes>
      {/* --- ROUTES PUBLIQUES --- */}
      <Route element={<Layout hideHeader />}>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/previewarticle/:id" element={<PreviewArticle/>} />
      </Route>

      {/* --- ROUTES RÉSERVÉES AUX AGENTS --- */}
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["agent"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/agent-home" element={<AgentHome />} />
          <Route path="/agent-clients" element={<AgentClients />} />
          <Route path="/agent-statistic" element={<AgentStatistic />} />
        </Route>
      </Route>

      {/* --- ROUTES RÉSERVÉES AUX SUPER AGENT --- */}
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["admin", "super_admin", "super_agent"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/super-agent-home" element={<SuperAgentHome />} />
          <Route path="/super-agent-live" element={<Live />} />
          <Route path="/super-agent-statistic" element={<StatisticScreen />} />
        </Route>
      </Route>
      {/* --- ROUTES RÉSERVÉES AUX MARKETING --- */}

      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["marketing"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/super-agent-blog" element={<Blog />} />
          <Route path="/super-agent-list-blogs" element={<ListBlogs />} />
          <Route path="/detailarticle/:id" element={<DetailArticle/>} />
          <Route path="/gamification" element={<Gamification />} />
          <Route path="/game-details/:id" element={<GameDetailsByUser />} />


          {/* <Route path="/previewarticle/:id" element={<PreviewArticle/>} /> */}
          

          <Route path="/marketing-home" element={<HomeMarketing />} />
        </Route>
      </Route>

      {/* --- ROUTES RÉSERVÉES AUX ADMIN --- */}
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["admin"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/admin-home" element={<AdminHome />} />
        </Route>
      </Route>

      {/* --- ROUTES RÉSERVÉES AUX SUPER ADMIN --- */}
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["super_admin"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/super-admin-home" element={<SuperAdminHome />} />

          <Route path="/super-agent-finances" element={<Finance />} />
        </Route>
      </Route>

      {/* --- ROUTES RÉSERVÉES AUX SUPER ADMIN ET MARKETING--- */}

      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["super_admin","marketing"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/notification" element={<NotificationManager />} />
        </Route>
      </Route>

      {/* --- ROUTES PARTAGÉES (Accessibles par TOUS les connectés) --- */}
      <Route
        element={
          <ProtectedRoute
            isAuthenticated={isAuth}
            userRole={role}
            allowedRoles={["agent", "super_agent", "admin", "super_admin"]}
          />
        }
      >
        <Route element={<Layout />}>
          <Route path="/detailuser/:id" element={<DetailUser />} />
          <Route path="/transfert" element={<Transfert />} />
          <Route path="/clients" element={<Client />} />
          <Route path="/invoice" element={<Invoice />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/settings" element={<Settings />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route
        path="/not-found"
        element={
          <div className="p-20 text-center font-bold">
            404 - Page non trouvée
          </div>
        }
      />
      <Route
        path="*"
        element={
          <div className="p-20 text-center font-bold">
            404 - Page non trouvée
          </div>
        }
      />
    </Routes>
  );
};

export default PagesRoutes;
